import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiMoreHorizontal({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 14 15"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.83325 7.50016C5.83325 6.85583 6.35559 6.3335 6.99992 6.3335C7.64425 6.3335 8.16658 6.85583 8.16658 7.50016C8.16658 8.14449 7.64425 8.66683 6.99992 8.66683C6.35559 8.66683 5.83325 8.14449 5.83325 7.50016Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.91675 7.50016C9.91675 6.85583 10.4391 6.3335 11.0834 6.3335C11.7277 6.3335 12.2501 6.85583 12.2501 7.50016C12.2501 8.14449 11.7277 8.66683 11.0834 8.66683C10.4391 8.66683 9.91675 8.14449 9.91675 7.50016Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.75 7.50016C1.75 6.85583 2.27233 6.3335 2.91667 6.3335C3.561 6.3335 4.08333 6.85583 4.08333 7.50016C4.08333 8.14449 3.561 8.66683 2.91667 8.66683C2.27233 8.66683 1.75 8.14449 1.75 7.50016Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiMoreHorizontal;
